import * as React from 'react';
import { StockIndicator } from '@grandvisionhq/inventory';
import { DeliveryIndicator } from '@grandvisionhq/shipping';

const StockAndDelivery = ({ readOnly , availableQuantity , availability , deliveryResolver , allowBackOrder , hideStockAndDeliveryOnLineItem  })=>!readOnly && !hideStockAndDeliveryOnLineItem ? /*#__PURE__*/ React.createElement("div", {
        className: "line-item__stock-and-delivery"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item__delivery"
    }, /*#__PURE__*/ React.createElement(DeliveryIndicator, {
        view: "short",
        availability: availability ? [
            availability
        ] : [],
        deliveryResolver: deliveryResolver
    })), /*#__PURE__*/ React.createElement("div", {
        className: "line-item__stock"
    }, /*#__PURE__*/ React.createElement(StockIndicator, {
        allowBackOrder: allowBackOrder,
        stockCount: availableQuantity,
        // Channel availability is not saved on lineItems and can't be added
        // to the backend without major changes. Since it's required to calculate
        // the stock indication, we assume in the cart that its value is ONLINE,
        // because IN_STORE_ONLY items are never orderable. In the future this logic
        // will be replaced by a GraphQL query.
        // Channel availability is not saved on lineItems and can't be added
        // to the backend without major changes. Since it's required to calculate
        // the stock indication, we assume in the cart that its value is ONLINE,
        // because IN_STORE_ONLY items are never orderable. In the future this logic
        // will be replaced by a GraphQL query.
        channelAvailability: "ONLINE"
    }))) : null
;

export { StockAndDelivery };
//# sourceMappingURL=StockAndDelivery.js.map
